<script lang="ts">
	import { postOperationCode } from '@app/services/api/operations';
	import { signInUpModalStore } from '@app/stores/signInUpModal';
	import { urls } from '@app/urls';
	import IconLottie from '$lib/elements/IconLottie.svelte';
	import Box from '$lib/components/boxes/Box.svelte';
	import InputPinCode from '$lib/elements/inputs/variants/InputPinCode.svelte';
	import ButtonBoxSecondary from '$lib/elements/buttons/variants/ButtonBoxSecondary.svelte';
	import AlertInfo from '@app/components/alerts/AlertInfo.svelte';
	import ButtonBoxPrimary from '$lib/elements/buttons/variants/ButtonBoxPrimary.svelte';
	import { t } from 'svelte-i18n';
	import { page } from '$app/stores';
	import PageHead from '@app/components/PageHead.svelte';
	import { snackbar } from '$lib/stores';
	import { goto } from '$app/navigation';
	import RecaptchaForm from '@app/components/RecaptchaForm.svelte';
	import { browser } from '$app/environment';
	import { onDestroy } from 'svelte';
	import ButtonText from '$lib/elements/buttons/variants/ButtonText.svelte';

	let inputPinCodeValue: string;
	let codeFromURL: string = '';
	let triggerMorph: boolean = false;
	let isFetching: boolean;
	let isAnimationComplete: boolean;
	let isMorphAnimationComplete: boolean;
	let operationID: string;

	$: isMorphAnimationComplete && goto(urls.PROJECT.INDEX(operationID));

	const postCode = async (recaptchaToken: string | undefined) => {
		isFetching = true;
		try {
			const data = await postOperationCode(inputPinCodeValue, recaptchaToken);
			operationID = data.accesOperationId.toString();
			triggerMorph = true;
		} catch (e) {
			snackbar.danger(
				e.message
					? e.message
					: e.httpStatus === 409
						? $t('privateOperationCodeError')
						: $t('register.errors.default')
			);
		} finally {
			isFetching = false;
		}
	};

	$: if ($page.data?.code && isAnimationComplete) {
		codeFromURL = $page.data?.code;
	}

	onDestroy(() => {
		$signInUpModalStore.privateOperationCode = undefined;
	});
</script>

<PageHead title={$t('titles.projectPrivateAccess')} />

<section>
	<div class="container md:w-1/2 pt-4 lg:pt-6 text-center">
		<h1>{$t('operation.messages.privateAccess')}</h1>
		<div class="space-y-4 pb-4">
			<div class="flex items-center justify-center">
				<Box
					props={{
						color: 'white',
						classNames: 'flex flex-col items-center justify-center gap-3 w-full'
					}}
				>
					<div class="flex justify-center h-[80px]">
						<IconLottie
							name="lock-unlock"
							classNames="!w-[80px] !h-[80px]"
							animationOnHover={false}
							speed={0.5}
							speedMorph={0.3}
							bind:isAnimationComplete
							bind:isMorphAnimationComplete
							{triggerMorph}
						/>
					</div>
					<div class="lg:w-1/2 h-[50px]">
						{#if browser && isAnimationComplete}
							<RecaptchaForm
								hasToTriggerSubmit={$page.data?.user !== null &&
									inputPinCodeValue !== '' &&
									inputPinCodeValue !== undefined}
								submitCallback={postCode}
								classNames="w-full"
							>
								<InputPinCode
									numberOfCharacters={5}
									{codeFromURL}
									bind:inputPinCodeValue
									{isFetching}
								/>
							</RecaptchaForm>
						{/if}
					</div>
					{#if !inputPinCodeValue}
						<p class="text-center">{$t('privateOperationCodeLabel')}</p>
					{/if}
					{#if inputPinCodeValue}
						{#if !$page.data?.user}
							<div class="flex gap-4">
								<ButtonBoxPrimary
									props={{ label: $t('nav.header.login') }}
									on:click={() => {
										signInUpModalStore.open();
									}}
								/>
								<ButtonBoxSecondary
									props={{ label: $t('nav.header.signup') }}
									on:click={() => {
										signInUpModalStore.open();
										signInUpModalStore.switchPanel('register');
										$signInUpModalStore.privateOperationCode = inputPinCodeValue;
									}}
								/>
							</div>
						{/if}
					{/if}
				</Box>
			</div>
			<AlertInfo label={$t('privateOperationAlertTitle')}>
				<div slot="body" class="text-left">
					{$t('privateOperationAlertDesc')}
					<span class="underline">
						<ButtonText
							props={{
								label: $t('profile.isWalletPendingOrOK.linkLabel'),
								href: urls.ABOUT.CONTACT
							}}
						/></span
					>.
				</div>
			</AlertInfo>
		</div>
	</div>
</section>
